<template>
  <div class="grey lighten-4" style="min-height: 100vh;">
    <!-- Modern Stats Dashboard -->
    <v-row dense class="px-4 pt-4 mb-2">
      <v-col cols="6" sm="4" md="2">
        <v-card class="stat-card pa-3">
          <div class="d-flex align-center mb-1">
            <v-icon x-small color="primary" class="mr-1">mdi-gauge</v-icon>
            <span class="stat-label">Capacidad</span>
          </div>
          <div class="stat-value text-primary">{{ totalProyectado }}</div>
        </v-card>
      </v-col>
      <v-col cols="6" sm="4" md="2">
        <v-card class="stat-card pa-3">
          <div class="d-flex align-center mb-1">
            <v-icon x-small color="success" class="mr-1">mdi-calendar-check</v-icon>
            <span class="stat-label">Reservas</span>
          </div>
          <div class="stat-value">{{ totalReservas }}</div>
        </v-card>
      </v-col>
      <v-col cols="6" sm="4" md="2">
        <v-card class="stat-card pa-3">
          <div class="d-flex align-center mb-1">
            <v-icon x-small color="info" class="mr-1">mdi-account-group</v-icon>
            <span class="stat-label">Jugadores</span>
          </div>
          <div class="stat-value">{{ totalPlayers - totalCancelados }}</div>
          <div class="caption grey--text text--darken-1 mt-1">
            {{ totalCancelados }} cancelados
          </div>
        </v-card>
      </v-col>
      <v-col cols="6" sm="4" md="2">
        <v-card class="stat-card pa-3">
          <div class="d-flex align-center mb-1">
            <v-icon x-small color="emerald" class="mr-1">mdi-check-circle</v-icon>
            <span class="stat-label">Checked In</span>
          </div>
          <div class="stat-value success--text">{{ totalPagados }}</div>
        </v-card>
      </v-col>
      <v-col cols="6" sm="4" md="2">
        <v-card class="stat-card pa-3">
          <div class="d-flex align-center mb-1">
            <v-icon x-small color="orange" class="mr-1">mdi-clock-outline</v-icon>
            <span class="stat-label">Pendientes</span>
          </div>
          <div class="stat-value orange--text">{{ totalPendientes }}</div>
        </v-card>
      </v-col>
      <v-col cols="6" sm="4" md="2">
        <v-card class="stat-card pa-3">
          <div class="d-flex align-center mb-1">
            <v-icon x-small color="blue" class="mr-1">mdi-door-open</v-icon>
            <span class="stat-label">Disponible</span>
          </div>
          <div class="stat-value blue--text">{{ totalProyectado - (totalPendientes + totalPagados + totalNoShow) }}
          </div>
        </v-card>
      </v-col>
    </v-row>

    <!-- Sticky Header Navigation -->
    <v-card class="sticky-nav px-4 py-2" elevation="0">
      <v-row align="center" no-gutters>
        <v-col cols="12" md="3" class="pr-md-4">
          <v-menu ref="menu" v-model="menu" :close-on-content-click="true" transition="scale-transition" offset-y
            min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="date" label="Fecha" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs"
                v-on="on" outlined dense hide-details class="search-field-modern"></v-text-field>
            </template>
            <v-date-picker v-model="date" @change="updateSelectedDate()" @update:picker-date="pickerUpdate($event)"
              no-title @input="menu = false" scrollable color="primary" header-color="primary"></v-date-picker>
          </v-menu>
        </v-col>

        <v-col cols="12" md="6" class="d-none d-md-flex justify-center">
          <v-btn-toggle mandatory dense borderless background-color="transparent">
            <v-btn v-for="(day, indexDay) in commingDays" :key="indexDay" :value="day.Date"
              @click="updateSelectedDateSuggest(day.Date)" class="date-btn-modern mx-1">
              {{ day.Nombre }}
            </v-btn>
          </v-btn-toggle>
        </v-col>

        <v-col cols="12" md="3" class="text-right d-flex align-center justify-end">
          <v-btn small depressed color="success" class="rounded-lg mr-2 font-weight-bold" @click="goRoute('/starter')">
            <v-icon left size="16">mdi-golf-tee</v-icon> Vista Starter
          </v-btn>
          <v-btn small depressed color="primary" class="rounded-lg mr-2" @click="showFilters = true">
            <v-icon left size="16">mdi-filter-variant</v-icon> Filtros
          </v-btn>
          <v-menu bottom left offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list dense class="rounded-lg">
              <v-list-item @click="generateReportStarter()">
                <v-list-item-icon><v-icon small>mdi-file-export</v-icon></v-list-item-icon>
                <v-list-item-title>Exportar Tee Sheet</v-list-item-title>
              </v-list-item>
              <v-list-item @click="showCancelados = !showCancelados; buildTimesData();">
                <v-list-item-icon><v-icon small>{{ showCancelados ? 'mdi-eye-off' : 'mdi-eye'
                }}</v-icon></v-list-item-icon>
                <v-list-item-title>{{ showCancelados ? "Ocultar Cancelados" : "Ver Cancelados" }}</v-list-item-title>
              </v-list-item>
              <v-list-item @click="showSearchFolio = true">
                <v-list-item-icon><v-icon small>mdi-magnify</v-icon></v-list-item-icon>
                <v-list-item-title>Búsqueda por Folio</v-list-item-title>
              </v-list-item>
              <v-list-item @click="showBloqueoHora = true">
                <v-list-item-icon><v-icon small>mdi-lock-clock</v-icon></v-list-item-icon>
                <v-list-item-title>Bloquear Horas</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>

        <v-col cols="12" md="9" class="mt-3">
          <v-autocomplete v-model="rvaSearched" :items="rvaList" :loading="isLoading" :search-input.sync="search"
            item-value="internalId" item-text="Nombre" outlined dense hide-details
            placeholder="Buscar jugador por nombre o folio..." @input="selectRvaList()"
            prepend-inner-icon="mdi-account-search" return-object class="search-field-modern shadow-sm"
            background-color="white"></v-autocomplete>
        </v-col>
        <v-col cols="12" md="3" class="mt-3">
          <v-select v-if="salidasDisponibles > 1" v-model="salida" :items="compSalidas" item-value="id"
            item-text="nombre" outlined dense hide-details placeholder="Salida" @input="init()"
            prepend-inner-icon="mdi-golf" class="search-field-modern shadow-sm" background-color="white"></v-select>
        </v-col>
      </v-row>
    </v-card>

    <div class="px-4 pb-10">
      <v-alert v-if="resGroup" border="left" colored-border type="info" elevation="1"
        class="rounded-lg mb-4 text-body-2">
        La reserva para grupos está habilitada. Se usarán los tee times siguientes a la hora seleccionada si es
        necesario.
      </v-alert>
      <!-- Modern Tee Sheet Grid -->
      <div v-if="!loadingData" class="teeTimes-modern">
        <table>
          <thead>
            <tr>
              <th scope="col" width="8%" class="text-center font-weight-bold" :rowspan="salida === 'ALL' ? 2 : 1">HORA
              </th>
              <template v-if="salida === 'ALL'">

                <th scope="col" v-for="bahia in getSalidas" :key="'h_' + bahia.id" :colspan="TeeSheet.slots.length"
                  class="text-center">{{ bahia.nombre }}</th>
              </template>
              <template v-else>
                <th scope="col" v-for="col in displayColumns" :key="'s' + col.slotIndex"
                  :width="92 / displayColumns.length + '%'" class="text-center">S{{ col.slotIndex + 1 }}</th>
              </template>
            </tr>
            <tr v-if="salida === 'ALL'">
              <th scope="col" v-for="(col, i) in displayColumns" :key="'sub_' + i"
                :width="92 / displayColumns.length + '%'" class="text-center">S{{ col.slotIndex + 1 }}</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(time, index) in times">
              <tr v-show="display(time.time)" :key="index">
                <td width="8%" @contextmenu.prevent.stop="handleClick($event, time, index)"
                  v-bind:class="[passTimeClass(time.time)]" class="time-column-modern"
                  @click="() => display(time.time) ? selectTime(time) : null">
                  {{ time.time }} <v-icon v-if="passTimeClass(time.time) !== ''">mdi-clock-alert-outline</v-icon>
                </td>

                <td v-for="(col, indexSlot) in displayColumns" :key="indexSlot"
                  :width="92 / displayColumns.length + '%'" class="slot-column-modern">
                  <template v-for="(player, indexPlayer) in time.slotPlayers[indexSlot]">
                    <v-tooltip :key="indexPlayer" color="primary" opacity="1" top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-card v-bind="attrs" v-on="on"
                          :class="['player-card-modern', String(player.FolioReserva), { 'noShowOpacity': player.E == 'N' }]"
                          :color="rowColor(player)" elevation="0" v-show="showByFilter(player)"
                          @contextmenu.prevent.stop="handleClickTeeTime($event, { indexPlayer: indexPlayer, player: player }, indexPlayer); setTimeSelected(time.time);"
                          @click="optionReservation(player)">
                          <!-- Status Bar Accent -->
                          <div class="status-accent"
                            :style="{ background: player.E == 'P' ? '#4CAF50' : player.E == 'C' ? '#F44336' : '#2196F3' }">
                          </div>

                          <v-card-text class="pa-2 pl-4 player-card-content" v-bind:style="{
                            color: rowTextColor(
                              time.slotPlayers[indexSlot][indexPlayer]
                            ),
                          }">
                            <!-- Top Row: Name and Cart -->
                            <div class="d-flex align-start justify-space-between mb-1">
                              <div class="player-name-modern text-truncate pr-2"
                                :title="player.Nom + (player.deda ? ' (ADEUDO)' : '')">
                                {{ player.Nom }}
                                <v-chip v-if="player.deda" x-small color="error" class="ml-1 px-1 font-weight-black"
                                  label>
                                  ADEUDO
                                </v-chip>
                              </div>
                              <div class="cart-indicator-modern flex-shrink-0" v-if="player.can">
                                <v-icon x-small color="inherit" class="mr-1">mdi-golf-cart</v-icon>
                                <span>{{ player.can }}</span>
                              </div>
                            </div>

                            <!-- Middle Row: Folio and Receipt -->
                            <div class="d-flex align-center mb-1 flex-wrap">
                              <span class="folio-label-modern mr-2">
                                <v-icon x-small left color="inherit" class="opacity-70">mdi-pound</v-icon>
                                {{ player.FolioReserva }}
                              </span>
                              <span v-if="player.fvta" class="receipt-label-modern">
                                <v-icon x-small left color="inherit" class="opacity-70">mdi-receipt</v-icon>
                                {{ player.fvta }}
                              </span>
                              <span v-if="player.bahia && salidasDisponibles > 1" class="receipt-label-modern">
                                <v-icon x-small left color="inherit" class="opacity-70">mdi-golf</v-icon>
                                {{ getNombreBahia(player.bahia) }}
                              </span>
                            </div>

                            <!-- Bottom Row: Transaction Info -->
                            <div class="transaction-info-modern mt-1">
                              <div class="text-truncate font-weight-bold" :title="player.trfr">
                                {{ player.trfr }}
                              </div>
                              <div v-if="player.cdtr" class="text-truncate opacity-80" style="font-size: 0.7rem"
                                :title="player.cdtr">
                                {{ player.cdtr }}
                              </div>
                            </div>
                          </v-card-text>
                        </v-card>
                      </template>
                      <div class="pa-2 font-weight-medium">
                        <p class="mb-1"><v-icon x-small color="white">mdi-account</v-icon> {{ player.Nom }}</p>
                        <p class="mb-1"><v-icon x-small color="white">mdi-tag-outline</v-icon> {{ player.trfr }}</p>
                        <p class="mb-1"><v-icon x-small color="white">mdi-note-text-outline</v-icon> {{ player.Notas ||
                          'Sin notas' }}
                        </p>
                        <p class="mb-0" v-if="player.phd"><v-icon x-small color="white">mdi-podium</v-icon> Handicap: {{
                          player.phd }}
                        </p>
                      </div>
                    </v-tooltip>
                  </template>

                  <v-btn v-if="time.slotPlayers[indexSlot].length == 0" block depressed class="add-slot-btn-modern"
                    @click="selectTime(time, col.bayId)">
                    <template v-if="!time.privado">
                      <v-icon small class="mr-1">mdi-plus</v-icon>
                      <span class="text-caption font-weight-bold">RESERVAR</span>
                    </template>
                    <div v-else class="text-center" style="width: 100%; min-width: 0; overflow: hidden;">
                      <v-icon small color="grey darken-4">mdi-lock</v-icon>
                      <div class="text-caption font-weight-black grey--text text--darken-4 text-truncate px-2">
                        <span class="marquee-hover">{{ time.privado.Mtv || "BLOQUEADO" }}</span>
                      </div>
                    </div>
                  </v-btn>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>

      <v-container v-if="loadingData" style="height: 400px">
        <v-row class="fill-height" align-content="center" justify="center">
          <v-col class="subtitle-1 text-center" cols="12">
            Cargando Tee Sheet
          </v-col>
          <v-col cols="6">
            <v-progress-linear :color="this.$pgsHelper.uiConfig().mainColor" indeterminate rounded
              height="6"></v-progress-linear>
          </v-col>
        </v-row>
      </v-container>

      <!-- Dialogs -->
      <v-row justify="center">
        <v-dialog v-model="dialog" fullscreen persistent hide-overlay transition="dialog-bottom-transition">
          <v-card>
            <v-toolbar dark color="primary">
              <v-btn icon dark @click="dialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-toolbar-title>Reserva</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text style="padding:14px">
              <teeSheetForm v-if="dialog" :SalidaSelectedTeesheet="selectedTimeData.selectedBayId || salida"
                :grupos="grupos" :Concierges="Concierges" :grupal="resGroup" @successData="successData"
                :Reservas="reservas" :key="indexSheetForm" :selectedT="selectedTimeData">
              </teeSheetForm>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-row>

      <v-row justify="center">
        <v-dialog v-model="dialogEdit" persistent fullscreen hide-overlay transition="dialog-bottom-transition">
          <v-card>
            <v-toolbar dark color="primary">
              <v-btn icon dark @click="dialogEdit = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-toolbar-title>Editar Reserva</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text style="padding:14px">
              <teeSheetEditForm v-if="dialogEdit" :subcategorias="subcategorias" :temporadas="temporadas"
                :tiposJuego="tiposJuego" :guessConfig="guessConfig" :ConfigRva="ConfigRva" :cajeros="cajeros"
                :Horarios="Horarios" :Addons="Addons" :Concierges="Concierges" @successData="successData"
                :tarifaCombo="tarifaCombo" :daysRules="daysRules" :editData="editData" :editMode="editMode"
                @closeModal="closeDialog" :key="indexSheetFormEdit"></teeSheetEditForm>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-row>

      <v-dialog v-model="dialogOptionRes" max-width="400">
        <v-card>
          <v-card-title class="headline">Opciones de la reservación</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="orange darken-1" text
              @click="dialogOptionRes = false; loadEditData(selectedResItem);">Editar</v-btn>
            <v-btn color="green darken-1" text @click="dialogOptionRes = false">Check In(PDV)</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="showFilters" max-width="400">
        <v-card>
          <v-card-title class="headline">Filtros</v-card-title>
          <v-card-text>
            <v-autocomplete v-model="Filters.grupo" :items="grupos" prepend-icon="mdi-view-list" outlined dense chips
              color="blue-grey lighten-2" label="Grupo Cliente" item-text="name" item-value="name" multiple>
              <template v-slot:selection="data">
                <v-chip small v-bind="data.attrs" :input-value="data.selected" @click="data.select">{{ data.item.name
                }}</v-chip>
              </template>
            </v-autocomplete>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="orange darken-1" text @click="resetFilters()">Limpiar filtros</v-btn>
            <v-btn color="green darken-1" text @click="showFilters = false">Aplicar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="showSearchFolio" max-width="400">
        <v-card>
          <v-card-title class="headline">Buscar por folio</v-card-title>
          <v-card-text>
            <v-text-field v-model="folioToFind" label="Folio de reserva"></v-text-field>
            <v-alert v-if="FolioNotFound" border="top" colored-border type="error" elevation="2">Folio no
              encontrado</v-alert>
            <v-btn @click="findByFolio()" class="text-right" color="primary">Buscar</v-btn>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="showBloqueoHora" :key="keyBloqueoHora" max-width="400">
        <v-card>
          <v-card-title class="headline">Bloquear rango de horas</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="6" md="6" class="input">
                <label>Hora inicial </label>
                <datetime type="time" input-id="iniTime" :min-datetime="bloquedTimes.minDate"
                  :max-datetime="bloquedTimes.maxDate" v-model="bloquedTimes.HoraInicial" :auto="false"
                  :format="{ hour: 'numeric', minute: '2-digit' }" :minute-step="10"></datetime>
              </v-col>
              <v-col cols="6" md="6" class="input">
                <label>Hora Final </label>
                <datetime type="time" input-id="endTime" v-model="bloquedTimes.HoraFinal" :minute-step="10"
                  :auto="false" :min-datetime="bloquedTimes.initialHour" :max-datetime="bloquedTimes.maxDate">
                </datetime>
              </v-col>
              <v-col v-if="bloquedTimes.HoraInicial != '' && bloquedTimes.HoraFinal != ''">
                <v-text-field outlined label="Motivo de bloqueo" v-model="bloquedTimes.Motivo"></v-text-field>
                <v-autocomplete v-model="bloquedTimes.status"
                  :items="[{ value: 1, text: 'Desbloquear' }, { value: 2, text: 'Bloquear' }]"></v-autocomplete>
                <v-btn @click="blockDataRange()" class="text-right mt-2" color="primary">Aplicar</v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- Context Menus -->
      <vue-context ref="menuIzquierdo">
        <v-list dense>
          <v-list-item @click="blockData(true)">
            <v-list-item-icon><v-icon>mdi-lock</v-icon></v-list-item-icon>
            <v-list-item-content><v-list-item-title>Bloquear hora</v-list-item-title></v-list-item-content>
          </v-list-item>
          <v-list-item @click="blockData(false)">
            <v-list-item-icon><v-icon>mdi-lock-open-variant</v-icon></v-list-item-icon>
            <v-list-item-content><v-list-item-title>Desbloquear hora</v-list-item-title></v-list-item-content>
          </v-list-item>
          <v-list-item @click="pasteBooking()">
            <v-list-item-icon><v-icon>mdi-content-paste</v-icon></v-list-item-icon>
            <v-list-item-content><v-list-item-title>Pegar Reserva</v-list-item-title></v-list-item-content>
          </v-list-item>
        </v-list>
      </vue-context>

      <vue-context ref="menuIzquierdoTeeTime">
        <v-list dense>
          <v-list-item @click="copyBooking()">
            <v-list-item-icon><v-icon>mdi-content-copy</v-icon></v-list-item-icon>
            <v-list-item-content><v-list-item-title>Copiar reserva</v-list-item-title></v-list-item-content>
          </v-list-item>
        </v-list>
      </vue-context>
    </div>
  </div>
</template>

<script>
//const $ = require('jquery');
//window.$ = $;

import moment from "moment";
import teeSheetForm from "../Reservas/BookingFormV3.vue";
import teeSheetEditForm from "../Reservas/BookingEditFormV3.vue";
import Reserva from "../../clases/Reserva.js";
import Cliente from "../../clases/Cliente.js";
import TarifasClass from "../../clases/Tarifa.js";
import "../../assets/css/custom.css";
import "../../assets/css/listTeeSheet.css";
import "../../assets/css/sideBar.css";
import pdfmake from "pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import VueContext from "vue-context";
import { mapGetters } from "vuex";
pdfmake.vfs = pdfFonts.pdfMake.vfs;
import ReporteStarter from "../../clases/PdfMakers/ReporteStarter.js";
export default {
  name: "reserva",
  components: {
    teeSheetEditForm,
    teeSheetForm,
    VueContext
  },
  data() {
    return {
      salidas: [{ id: 1, nombre: "Hoyo 1" }, { id: 2, nombre: "Hoyo 10" }],
      salida: 1,
      temporadas: [],
      guessConfig: {},
      ConfigRva: null,
      cajeros: [],
      FolioNotFound: false,
      folioToFind: null,
      showSearchFolio: false,
      showBloqueoHora: false,
      showFilters: false,
      Filters: {
        grupo: [],
      },
      keyBloqueoHora: 0,
      bloquedTimes: {
        Motivo: "BLOQUEADO",
        input_date: moment(),
        status: 2,
        HoraInicial: "",
        HoraFinal: "",
        minDate: "06:00",
        maxDate: "23:01",
      },
      grupos: [],
      tiposJuego: [],
      Concierges: [],
      tarifaCombo: [],
      rvaSearched: null,
      isLoading: false,
      search: null,
      resGroup: false,
      showCancelados: false,
      dialogOptionRes: false,
      indexSheetForm: 1,
      indexSheetFormEdit: 2,
      dialog: false,
      dialogEdit: false,
      notifications: false,
      sound: true,
      widgets: false,
      menu: false,
      date: moment().format("YYYY-MM-DD"),
      TeeSheet: {
        slots: [0, 1, 2, 3],
      },
      availableDates: [],
      selectedTimeData: [],
      editData: [],
      editMode: false,
      selectedResItem: {},
      totalReservas: 0,
      totalPlayers: 0,
      totalProyectado: 0,
      totalCancelados: 0,
      totalPagados: 0,
      totalNoShow: 0,
      totalPendientes: 0,
      showAll: false,
      MainDepartamento: "",
      //data_clientes:[],
      confirmBook: false,
      transModal: false,
      input_date: moment(),
      actualDate: moment(),
      isAdmin: false,
      loadingData: false,
      isPreferedTime: false,
      selectedTarifa: "",
      compIndex: 0,
      actualListener: "",
      prefered: true,
      RsvaTransId: "",
      forceRecomputeCounter: 0,
      // Confirm:"",
      modalOpen: false,
      selectedPriceIndex: "",
      selectedTime: "",
      times: [],
      reservas: [],
      daysRules: [],
      initTime: new moment("06:00", "HH:mm"),
      endTime: new moment("18:00", "HH:mm"),
      configTime: {},
      intervalo: 10,
      Horarios: [],
      subcategorias: [],
      highlighted: {
        dates: [
          // Highlight an array of dates
          new Date(moment()),
          //new Date(2020, 0, 17),
          //new Date(2020, 0, 18)
        ],
      },
    };
  },
  props: ["isHotel", "isWeb", "hideMenu"],
  methods: {
    getNombreBahia(id) {
      let salida = this.getSalidas.find((s) => s.id == id);
      return salida ? salida.nombre : "";
    },
    async copyBooking() {
      try {
        await navigator.clipboard.writeText(this.selectedReservation.player.id).then(() => {
          this.$toast.success(
            " ", "Reserva copiada"
          );
        })
      } catch (err) {
        console.error("Error al copiar: ", err);
      }
    },
    pasteBooking() {
      try {
        navigator.clipboard.readText().then(
          async (clipText) => {
            let dataReserva = await Reserva.getById(clipText);
            if (dataReserva) {
              try {
                let dataToSave = Reserva.cleanToCopy(dataReserva)
                dataToSave.RF.FI = this.date + "_" + this.selectedTimeContextClick.time
                this.bookNow(dataToSave)
              } catch (err) {
                this.$swal(
                  "Error al pegar la reserva",
                  "La reserva no puede copiarse (Pagada)",
                  "error"
                );
              }

            } else {
              this.$swal(
                "Error",
                "El elemento copiado no es una reserva",
                "error"
              );
            }

          }
        );
      } catch (err) {
        console.error("Error al pegar: ", err);
      }
    },
    setTimeSelected(time) {
      this.selectedHour = time;
    },
    handleClickTeeTime(event, data, index) {
      this.selectedReservation = data;
      this.$refs.menuIzquierdoTeeTime.open(event);
    },
    blockData(block) {
      let data = {
        date: this.date,
        times: [
          [
            this.selectedTimeContextClick.time,
            this.selectedTimeContextClick.time,
          ],
        ],
        block: block,
        Todos: true,
      };
      data.Departamento = "Golf";
      this.$alert.alertConfirm({
        action: block ? "bloquear" : "desbloquear",
        obj: "el horario " + this.selectedTimeContextClick.time,
        route: "RVA-TeeSheet-bloquearTeetime",
        data: data,
        onSuccess: (data) => { },
      });
    },
    blockDataRange() {
      let ini = moment(this.bloquedTimes.HoraInicial);
      let fini = moment(this.bloquedTimes.HoraFinal);

      let data = {
        date: this.date,
        times: [
          [
            ini.format("HH:mm:ss"),
            fini.format("HH:mm:ss"),
          ],
        ],
        block: this.bloquedTimes.status == 1 ? false : true,
        motivo: this.bloquedTimes.Motivo,
        Todos: true,
      };
      data.Departamento = "Golf";
      this.$alert.alertConfirm({
        action: this.bloquedTimes.status == 1 ? "desbloquear" : "bloquear",
        obj: "el horario " + ini.format("HH:mm:ss") + " a " + fini.format("HH:mm:ss"),
        route: "RVA-TeeSheet-bloquearTeetime",
        data: data,
        onSuccess: (data) => {
          this.showBloqueoHora = false
          this.keyBloqueoHora++;
        },
      });
    },
    async getSubcategoria() {
      const data = await this.$store.getters.getFirebaseApp.database.queryBuilder(
        "RVA/Tarifas/Golf/SubCategorias"
      );
      if (!data.exists()) {
        return false;
      }
      let arrayHoteles = Object.entries(data.val());

      arrayHoteles.forEach((element) => {
        this.subcategorias.push({
          id: element[0],
          key: element[0],
          text: element[1].Nombre,
          value: element[0],
          ...element[1],
        });
      });
    },
    async getConfig() {
      const conf = await this.$store.getters.getFirebaseApp.database.queryBuilder(
        "RVA/Configuracion/Golf"
      );
      let resultConf = conf.val();
      this.ConfigRva = resultConf;
      this.guessConfig = resultConf?.GUEST;
    },
    async getHorarios() {
      this.Horarios = [];
      const data = await this.$store.getters.getFirebaseApp.database.queryBuilder(
        "RVA/Tarifas/" + "Golf" + "/Horarios"
      );

      if (!data.exists()) {
        return false;
      }
      let arrayHorarios = Object.entries(data.val());
      var $this = this;
      arrayHorarios.forEach(function (element) {
        $this.Horarios.push({ id: element[0], ...element[1] });
      });
    },
    async getCajeros() {
      const snapshot = await this.$store.getters.getFirebaseApp.database.queryBuilder(
        "PDV/Cajeros"
      );

      if (snapshot.exists()) {
        this.cajeros = [];
        Object.keys(snapshot.val()).forEach((id) => {
          const toAdd = snapshot.val()[id];
          if (toAdd) {
            toAdd.Id = id;
            // ajustar usuarios antiguos
            this.cajeros.push(toAdd);
          }
        });
      }
    },
    handleClick(event, item, index) {
      this.selectedTimeContextClick = item;
      this.$refs.menuIzquierdo.open(event);
    },
    async findByFolio() {
      this.FolioNotFound = false
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      let data = await firestore.queryBuilder("RVA_Reservas", [
        firestore.where("Folio", "==", this.folioToFind),
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
      ]);
      let reservations = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });
      if (reservations[0]) {

        let dateToMove = moment(reservations[0].RF.FI, "YYYY-MM-DD_HH:mm:ss");
        this.date = dateToMove.format("YYYY-MM-DD");
        await this.updateSelectedDate();
        setTimeout(() => {
          try {
            this.scrollUntilExist(this.folioToFind);
          } catch (e) {
            console.log(e);
          }
        }, 2000);
        this.showSearchFolio = false
      } else {
        this.FolioNotFound = true

      }
    },
    scrollUntilExist(folio) {
      let element = document.getElementsByClassName(folio);
      if (element) {

        if (element[0]) {
          element[0].scrollIntoView({ block: "center" });
        }
      }
    },
    showByFilter(item) {
      let show = true;
      if (this.Filters.grupo.length > 0) {
        if (this.Filters.grupo.includes(item.grp)) {
          show = true;
        } else {
          show = false;
        }
      }
      return show;
    },
    resetFilters() {
      this.Filters = {
        grupo: [],
      };
    },
    rowColor: function (data) {
      let color =
        data.E == "R"
          ? data.colr == "D"
            ? "blue"
            : data.colr == "M"
              ? "orange"
              : data.colr || "blue"
          : data.E == "P"
            ? "green"
            : "red";
      if (data.E == "N") {
        return "#9e9e9e36"
      }
      if (data.deda) {
        return "#9d0b00";
      }

      return color;
    },
    rowTextColor(data) {
      let color =
        data.colr == "D"
          ? "white"
          : data.colr == "M"
            ? "white"
            : this.$pgsHelper.invertColor(data.colr);
      if (data.E == "P") {
        return "white";
      }
      if (data.deda) {
        return "white";
      }
      return color;
    },
    generateReportStarter() {
      let tenant = this.$store.getters.getFirebaseApp.tenant;
      let mainData = {
        FI: this.input_date.format("DD/MM/YYYY"),
        FG: new moment().format("DD/MM/YYYY"),
        HG: new moment().format("HH:mm:ss"),
        TITLE:
          tenant == "PCUN"
            ? "CLUBS PUERTO CANCUN SA DE CV"
            : tenant == "BOKA"
              ? "BOKKA SMOKEHOUSE & GRILL"
              : tenant == "TNTO"
                ? "EL TINTO GOLF COURSE"
                : "TEE SHEET",
        Times: this.times,
      };
      let docData = ReporteStarter.getDocData(mainData);
      pdfmake.createPdf(docData).open();
    },
    selectRvaList() {
      try {
        this.optionReservation(this.rvaSearched);
      } catch (e) {
        console.log(e);
      }
    },
    closeDialog() {
      this.dialogEdit = false;
    },
    passTimeClass(time) {
      let pointer = "";

      if (
        this.actualDate.format("YYYY-MM-DD HH:mm") >
        moment(
          this.input_date.format("YYYY-MM-DD") + time,
          "YYYY-MM-DD HH:mm"
        ).format("YYYY-MM-DD HH:mm")
      ) {
        //this.$pgsHelper.log(this.actualDate.format('YYYY-MM-DD HH:mm'));

        pointer = "cardDisabled";
        //pointer = "";
      }

      return pointer;
    },
    pointerClass: function (time) {
      let pointer = "";

      if (
        this.actualDate.format("YYYY-MM-DD HH:mm") >
        moment(
          this.input_date.format("YYYY-MM-DD") + time,
          "YYYY-MM-DD HH:mm"
        ).format("YYYY-MM-DD HH:mm")
      ) {
        //this.$pgsHelper.log(this.actualDate.format('YYYY-MM-DD HH:mm'));

        //pointer = "cardDisabled";
        pointer = "";
      }

      return pointer;
    },
    display: function (time) {
      let show = true;

      if (
        this.actualDate.format("YYYY-MM-DD HH:mm") >
        moment(
          this.input_date.format("YYYY-MM-DD") + time,
          "YYYY-MM-DD HH:mm"
        ).format("YYYY-MM-DD HH:mm")
      ) {
        show = false;
      }

      if (this.showAll) {
        show = true;
      }

      return true;
    },
    successData(data, doAction) {
      if (doAction == "CREATE") {
        this.bookNow(data);
      } else if (doAction == "EDIT") {
        this.editReserva(data);
      }
    },
    selectTime(time, bayId = null) {
      (this.editData = []), (this.editMode = false), this.indexSheetForm++;
      moment.locale("es");
      time.date = moment(this.date);
      if (bayId) time.selectedBayId = bayId;
      this.selectedTimeData = time;
      this.dialog = true;
    },
    updateSelectedDate() {
      this.loadingData = true;
      this.selectDate(this.date);
    },
    updateSelectedDateSuggest(day) {
      this.loadingData = true;
      this.date = day;
      this.selectDate(this.date);
    },
    pickerUpdate(val) {
      let totalDay = moment(val, "YYYY-MM").daysInMonth();
      let weekDay = [];

      let disable_dates = [];
      let open_dates = [];

      this.daysRules.forEach((element) => {
        if (element.data === false) {
          disable_dates.push(element.date, "YYYY-MM-DD");
        } else {
          open_dates.push(element.date);
        }
      });

      let availableDates = [];

      let monthNow = moment().format("M");
      let monthSelected = moment(val).format("M");
      let day;

      if (monthNow == monthSelected) day = moment().format("D");
      else day = 1;

      for (let i = day; i <= totalDay; i++) {
        let date = moment()
          .month(val.split("-")[1] - 1)
          .date(i)
          .format("YYYY-MM-DD");
        if (
          !weekDay.includes(moment(date).day()) &&
          !disable_dates.includes(date)
        ) {
          availableDates.push(date);
        }

        if (weekDay.includes(moment(date).day()) && open_dates.includes(date)) {
          availableDates.push(date);
        }
      }
      this.availableDates = availableDates;
      this.allowedDates();
    },
    allowedDates(a) {
      return this.availableDates.includes(a);
    },
    async init() {
      this.loadingData = true;
      await this.getDaysRules();
      await this.getReservas();
      await this.buildTimesData();
    },
    toggleModal() {
      this.modalOpen = !this.modalOpen;
    },
    showPrefered() {
      this.resetSelect();
      if (this.prefered) {
        /* this.times.forEach((element)=>{
                   element.prefered = false;
           });*/
        this.times.forEach((element, index) => {
          if (element.personas > 0 && element.prefered == true) {
            this.times[index - 1].preferedClass = true;
            element.preferedClass = true;
            this.times[index + 1].preferedClass = true;
          }
        });
      } else if (this.prefered === false) {
        this.times.forEach((element) => {
          element.preferedClass = true;
        });
      }
    },
    setSelectedTime(key, time, idTarifa, prefered) {
      //alert(key + ' ' + time + ' ' + total);

      this.selectedPriceIndex = key;
      this.selectedTime = time;
      this.selectedTarifa = idTarifa;
      this.isPreferedTime = prefered;

      this.$nextTick(() => {
        document.getElementById("dataClient").scrollIntoView();
      });
    },
    selectDate(arg) {
      let oldDate = this.input_date.format("YYYY-MM-DD");
      this.killListener(oldDate);
      this.input_date = moment(arg);
      this.resetSelect();
      this.selectedTime = "";
      this.selectedPrice = "";
      this.init();
    },
    setInitialDate() {
      this.input_date.format("YYYY-MM-DD");
      let aux = false;
      /*this.daysRules.forEach((element) => {
        if (element.data.Abre && element.data.Cierra) {
          if (this.input_date.format("YYYY-MM-DD") === element.date) {
            this.initTime = new moment(element.data.Abre, "HH:mm:ss");
            this.endTime = new moment(element.data.Cierra, "HH:mm:ss");
            aux = true;
          }
        }
      });*/
      if (!aux) {
        this.initTime = this.configTime.initTime;
        this.endTime = this.configTime.endTime;
      }
    },
    killListener(date) {
      const ref = this.$store.getters.getFirebaseApp.database.ref(
        "RVA/Reservas/" + this.MainDepartamento + "/" + date
      );
      this.$store.getters.getFirebaseApp.database.off(ref);
    },
    selectPaid(value) {
      this.$store.commit("setTypePaid", value);
      //this.getTarifas();
    },
    resetSelect() {
      this.selectedPriceIndex = "";
      this.isPreferedTime = false;
      document.getElementsByName("trans").forEach((element) => {
        element.checked = false;
      });
      this.$store.commit("setPriceSelected", 0);
    },
    goRoute(routePath) {
      this.$router.push({ path: routePath });
    },
    async getReservas() {
      /*
            Se obtiene las disponibilidad por dia y la cantidad de personas reservadas en esos dias
        */
      this.totalReservas = 0;
      let date = this.input_date.format("YYYY-MM-DD");
      this.killListener(this.actualListener);
      this.$store.getters.getFirebaseApp.database.queryBuilderListener(
        "RVA/Reservas/" + this.MainDepartamento + "/" + date,
        null,
        (snapshot) => {
          try {
            if (snapshot.exists()) {
              this.reservas = [];
              let arrayReservas = snapshot.val();
              let reservaList = Reserva.parseAvailabilityData(arrayReservas, this.salida, this.getSalidas);
              if (this.salida != "ALL") {
                this.reservas = reservaList.filter((reserva) => {
                  return (reserva.bahia == this.salida);
                });
              } else {
                this.reservas = reservaList;
              }
              this.totalPlayers = 0;
              this.totalCancelados = 0;
              this.totalPagados = 0;
              this.totalNoShow = 0;
              this.totalPendientes = 0;
              this.reservas.forEach((element) => {
                this.totalPlayers =
                  this.totalPlayers +
                  (element.rvsData ? element.rvsData.length : 0);
                if (element.Rvs) {
                  this.totalReservas =
                    this.totalReservas + Object.keys(element.Rvs).length;
                }
                if (element.rvsData) {
                  element.rvsData.forEach((ply) => {
                    if (ply.E) {
                      if (ply.E == "P") {
                        this.totalPagados++;
                      }
                      if (ply.E == "R") {
                        this.totalPendientes++;
                      }
                      if (ply.E == "C") {
                        this.totalCancelados++;
                      }
                      if (ply.E == "N") {
                        this.totalNoShow++
                      }
                    }
                  });
                }
              });
            } else {
              this.reservas = [];
              this.totalPlayers = 0;
              this.totalCancelados = 0;
              this.totalPagados = 0;
              this.totalNoShow = 0
              this.totalPendientes = 0;
            }
          } catch (e) {
            console.log(e);
          }

          this.buildTimesData();
        }
      );
      this.actualListener = date;
    },
    async getDaysRules() {
      try {
        this.$store.getters.getFirebaseApp.database.queryBuilderListener(
          "RVA/Configuracion/" + this.MainDepartamento + "/Calendario",
          null,
          (snapshot) => {
            if (snapshot.exists()) {
              this.daysRules = [];
              if (snapshot.val().Fechas_Especiales) {
                let arrayCalendar = Object.entries(
                  snapshot.val().Fechas_Especiales
                );
                arrayCalendar.forEach((element) => {
                  this.daysRules.push({ date: element[0], data: element[1] });
                });

                //ordena las reglas por fecha
                this.daysRules.sort(function compare(a, b) {
                  return a.date - b.date;
                });
                this.configTime.initTime = new moment(
                  snapshot.val().Hora_Apertura,
                  "HH:mm:ss"
                );
                this.configTime.endTime = new moment(
                  snapshot.val().Hora_Cierre,
                  "HH:mm:ss"
                );
              } else {
                this.configTime.initTime = new moment(
                  snapshot.val().Hora_Apertura,
                  "HH:mm:ss"
                );
                this.configTime.endTime = new moment(
                  snapshot.val().Hora_Cierre,
                  "HH:mm:ss"
                );
                this.daysRules = [];
              }
            } else {
              this.daysRules = [];
            }
          }
        );
      } catch (e) {
        console.log(e);
      }
    },
    optionReservation(data) {
      this.selectedResItem = data;
      this.loadEditData(data);
      //this.dialogOptionRes = true;
    },
    async loadEditData(data) {
      if (!data) {
        return false
      }
      let dataReserva = await Reserva.getById(data.id);
      dataReserva = Reserva.TransformarReserva(dataReserva);
      let cuentas = Object.entries(dataReserva.Cuentas);
      dataReserva.Cuentas = cuentas.map((doc) => {
        return { indexCuenta: doc[0], ...doc[1] };
      });
      console.log(dataReserva)
      this.editData = dataReserva;
      this.editMode = true;
      this.indexSheetFormEdit++;
      this.dialogEdit = true;
    },
    buildTimesData() {
      /*
            Genera el array conteniendo cada horario disponible para reserva en un intervalo de 10 minutos desde la hora inicial y la hora final
        */
      try {
        this.initTime = "";
        this.endTime = "";
        this.setInitialDate();
        let initTim = new moment(this.initTime.format("HH:mm"), "HH:mm");
        let endTime = new moment(this.endTime.format("HH:mm"), "HH:mm");

        let auxDate = initTim;
        this.times = [];
        this.totalProyectado = 0;
        var i;
        /*para cada uno de los horarios armados se asignan los datos necesarios*/
        for (i = 0; auxDate.format("HH:mm") <= endTime.format("HH:mm"); i++) {
          var idTarifa;
          var precio;
          var idTarifaGlobal = "";
          var precioGlobal = "";
          let personas = 0;
          let privado = false;

          let players = [];
          let slotPlayers = [];
          //
          this.totalProyectado += this.displayColumns.length;
          this.displayColumns.forEach((col, index) => {
            slotPlayers[index] = [];
          });
          /*en caso de que tengan reservas en ese Horario y dia seleccionado se agregan a los datos*/
          this.reservas.forEach((element) => {
            let time = new moment(element.time, "HH:mm:ss");
            if (time.format("HH:mm") == auxDate.format("HH:mm")) {
              this.$pgsHelper.log(element);
              players = element.rvsData ? element.rvsData : [];
              let bahiaId = element.bahia;
              let targetCols = [];
              for (let c = 0; c < this.displayColumns.length; c++) {
                if (this.displayColumns[c].bayId == bahiaId) targetCols.push(c);
              }
              if (targetCols.length === 0) targetCols = this.displayColumns.map((_, i) => i);

              let slotPlayerNum = 0;
              players.forEach((player) => {
                if (
                  player.E == "R" ||
                  player.E == "P" ||
                  player.E == "N" ||
                  this.showCancelados == true
                ) {
                  let actualColIndex = targetCols[slotPlayerNum];
                  if (actualColIndex !== undefined) {
                    slotPlayers[actualColIndex].push(player);
                  }
                  if (slotPlayerNum == targetCols.length - 1) {
                    slotPlayerNum = 0;
                  } else {
                    slotPlayerNum++;
                  }
                }
              });
              let rvs = element.Rvs ? element.Rvs : {};
              let rvsArray = Object.entries(rvs);
              rvsArray.forEach((res) => {
                if (res[1].Pys) {
                  res[1].Pys.forEach((ply) => {
                    if (ply.E == "R" || ply.E == "P") {
                      personas++;
                    }
                  });
                }
              });

              //personas = element.PAX;

              privado = element.Privado ? element.Privado : false;
            }
          });

          /* se agregan al array*/
          this.times.push({
            time: auxDate.format("HH:mm"),
            tarifaId: idTarifa,
            tarifaIdGlobal: idTarifaGlobal,
            precioGlobal: precioGlobal,
            precio: precio,
            personas: personas,
            privado: privado,
            players: players,
            slotPlayers: slotPlayers,
            prefered: false,
          });
          auxDate = auxDate.add(10, "minutes");
        }

        this.loadingData = false;
      } catch (e) {
        this.loadingData = false;
      }
    },
    editReserva(datos) {
      let reservationData = datos;
      this.$swal({
        title: "¿Deseas editar esta reserva?",
        text: "Los datos de la reserva seran modificados",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Editar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          //var addReserva = this.$store.getters.getFirebaseApp.fba.call('RVA-Reservas-crearReserva');
          return await this.$store.getters.getFirebaseApp.fba
            .call("RVA-Reservas-editarReserva", reservationData)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal({
              title: "¡¡Guardado Correctamente",
              text: "Tu reservación se guardo correctamente",
              icon: "success",
            }).then(() => {
              if (this.isWeb) {
                location.href = "https://www.puertocancun.com";
              } else {
                this.dialogEdit = false;
                //this.$emit('changeIndex');
              }
            });

            //this.$emit('changeIndex');
          } else {
            this.$swal(
              "Error guardando la reserva",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    async getTarifarios() {
      let tarifarios = await TarifasClass.getMixTarifasCombo("Golf");
      tarifarios.forEach((element) => {
        element.value = element.Id;
        element.text = element.Nombre;
      });
      this.tarifaCombo = tarifarios;
    },
    bookNow(datos) {
      let reservationData = datos;
      this.$pgsHelper.log(reservationData, true);
      this.$swal({
        title: "¿Deseas generar esta reserva?",
        text:
          "Los datos de la reserva afectaran la disponibilidad del dia y hora seleccionado",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Reservar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          let ruta = reservationData.grupal
            ? "RVA-Reservas-reservarGrupo"
            : "RVA-Reservas-crearReserva";
          //var addReserva = this.$store.getters.getFirebaseApp.fba.call('RVA-Reservas-crearReserva');
          return await this.$store.getters.getFirebaseApp.fba
            .call(ruta, reservationData)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            let transReservation = "";
            if (result.value.data.data.Transportacion) {
              transReservation =
                "Numero de transportación:" +
                result.value.data.data.Transportacion.Confirmacion;
            }

            this.$swal({
              title: "¡¡Reservado",
              text:
                "Tu reservación se guardo correctamente, te enviamos un email con la información de la reserva. Reservación No. " +
                result.value.data.data.Folio +
                " " +
                transReservation,
              icon: "success",
            }).then(() => {
              if (this.isWeb) {
                location.href = "https://www.puertocancun.com";
              } else {
                this.dialog = false;
                //this.$emit('changeIndex');
              }
            });

            //this.$emit('changeIndex');
          } else {
            if (result.value.data.code == "RESTRICTED/TEETIME") {
              this.$swal({
                icon: "error",
                title: result.value.data.error,
                showCancelButton: true,
                confirmButtonText: "Forzar reserva",
              }).then(async (result) => {
                if (result.isConfirmed) {
                  this.bookNow({ Force: true, ...datos })
                }

              });
            } else {
              this.$swal(
                "Error guardando la reserva",
                result.value.data.error,
                "error"
              );
            }

          }
        }
      });
    },
    async getUserGroups() {
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      var data = await firestore.queryBuilder("PDV_GruposCliente", [
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
      ]);

      let document = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });
      let gps = [];
      if (document) {
        document.forEach((doc) => {
          if (doc.gps) {
            let grupos = Object.entries(doc.gps);
            grupos.forEach((element) => {
              if (element[1]) {
                gps.push({
                  name: element[0],
                });
              }
            });
            this.grupos = gps;
          }
        });
      }
    },
    async getConcierges() {
      const data = await this.$store.getters.getFirebaseApp.database.queryBuilder(
        "RVA/Concierge"
      );
      if (!data.exists()) {
        return false;
      }
      let concierges = Object.entries(data.val());
      let conciergesData = [];
      concierges.forEach(function (element) {
        conciergesData.push({
          id: element[0],
          ...element[1],
        });
      });
      this.Concierges = conciergesData;
    },
    async getTiposJuego() {
      const data = await this.$store.getters.getFirebaseApp.database.queryBuilder(
        "RVA/Tarifas/Golf/Modalidades"
      );
      //validar if exist
      if (data.exists()) {
        let arrayTipos = Object.entries(data.val());
        var $this = this;
        arrayTipos.forEach((element) => {
          this.tiposJuego.push({
            id: element[0],
            codigo: element[1]["Codigo"],
            nombre: element[1]["Nombre"],
          });
        });
      }

    },
    async getTemporadas() {
      /*
        Obtiene las temporadas existentes en la db
        */
      const data = await this.$store.getters.getFirebaseApp.database.queryBuilder(
        "RVA/Tarifas/Golf/Temporadas"
      );
      if (!data.exists()) {
        return false;
      }
      let arrayTarifas = Object.entries(data.val());
      arrayTarifas.forEach((element) => {
        if (element[1].Activo) {
          this.temporadas.push({ id: element[0], ...element[1] });
        }
      });
    },
  },
  computed: {
    ...mapGetters(["getSalidas"]),
    displayColumns() {
      let cols = [];
      if (this.salida === 'ALL') {
        let salidasArray = [];
        this.getSalidas.forEach(bahia => {
          salidasArray.push({
            id: bahia.id,
            nombre: bahia.nombre
          });
        });
        salidasArray.forEach(bahia => {
          if (bahia.id !== 'ALL') {
            this.TeeSheet.slots.forEach(slot => {
              cols.push({ bayId: bahia.id, bayName: bahia.nombre, slotIndex: slot });
            });
          }
        });
      } else {
        this.TeeSheet.slots.forEach(slot => {
          cols.push({ bayId: this.salida, bayName: '', slotIndex: slot });
        });
      }
      return cols;
    },
    compSalidas() {
      let salidas = [];
      this.getSalidas.forEach(bahia => {
        salidas.push({
          id: bahia.id,
          nombre: bahia.nombre
        });
      });
      salidas.push({
        id: "ALL",
        nombre: "TODOS"
      })
      return salidas;
    },
    salidasDisponibles() {
      if (this.ConfigRva?.Calendario.Salidas) {
        return this.ConfigRva.Calendario.Salidas;
      }
      return 1;
    },
    Addons() {
      /*
        Obtiene las temporadas existentes en la db
        */
      let AddOn = {};
      let addons = this.$store.getters.getRVACatalogo;
      AddOn.cartRider = addons.GOLFRIDDER || { Precio: 0, Moneda: 0 }; //arrayExt;
      AddOn.golfClub = addons.GOLFCLUB || { Precio: 0, Moneda: 0 }; //arrayGb;
      AddOn.transport = addons.TRANSPORT || { Precio: 0, Moneda: 0 };
      AddOn.roundGolf = addons.GOLFROUND || { Precio: 0, Moneda: 0 };
      return AddOn;
    },
    rvaList() {
      let data = [];
      if (this.reservas) {
        try {
          this.reservas.forEach((teeTime) => {
            if (teeTime.rvsData) {
              teeTime.rvsData.forEach((player) => {
                player.internalId = player.id + "||" + player.Cta;
                if (player.E == "R" || player.E == "P") {
                  player.Nombre = player.Nom + " TeeTime:" + teeTime.time;
                  data.push(player);
                }
              });
            }
          });
          let dataFilter = [];
          if (this.search != "" && this.search) {
            dataFilter = data.filter((acc) => {
              if (
                acc?.Nombre?.toUpperCase().includes(this.search.toUpperCase())
              ) {
                return true;
              } else {
                return false;
              }
            });
          }
          return dataFilter;
        } catch (e) {
          return data;
        }
      } else {
        return data;
      }
    },
    commingDays() {
      try {
        let disable_dates = [];
        let open_dates = [];
        let weekDay = [];
        this.daysRules.forEach((element) => {
          if (element.data === false) {
            disable_dates.push(element.date, "YYYY-MM-DD");
          } else {
            open_dates.push(element.date);
          }
        });
        let numberToShow = 4;
        let days = [];

        let actual = moment();
        for (var i = 0; days.length <= numberToShow; i++) {
          let hoy = moment();
          let isToday = false;
          if (actual.format("YYYY-MM-DD") == hoy.format("YYYY-MM-DD")) {
            isToday = true;
          }

          if (!weekDay.includes(actual.day())) {
            days.push({
              Nombre: isToday ? "Hoy" : actual.format("ddd - DD"),
              Date: actual.format("YYYY-MM-DD"),
            });
          }

          if (
            weekDay.includes(actual.day()) &&
            open_dates.includes(actual.format("YYYY-MM-DD"))
          ) {
            days.push({
              Nombre: isToday ? "Hoy" : actual.format("ddd - DD"),
              Date: actual.format("YYYY-MM-DD"),
            });
          }
          actual.add(1, "days");
        }

        return days;
      } catch (e) {
        return [];
      }
    },
    typePaid() {
      return this.$store.getters.getTypePaid;
    },
    computedStep() {
      let step = 3;
      let stepTrans = 4;
      let stepExtraInfo = 5;
      if (this.isHotel) {
        if (this.typePaid == 2) {
          step = 5;
          stepExtraInfo = 6;
        } else if (this.typePaid == 1) {
          step = 6;
          stepExtraInfo = 7;
        } else if (this.typePaid == "") {
          step = 5;
          stepExtraInfo = 6;
        }
      }

      return {
        stepTime: step,
        stepExtraInfo: stepExtraInfo,
        stepTrans: stepTrans,
      };
    },
    disabledDates() {
      try {
        let disable_dates = [];
        let open_dates = [];

        this.daysRules.forEach((element) => {
          if (element.data === false) {
            disable_dates.push(new Date(moment(element.date, "YYYY-MM-DD")));
          } else {
            open_dates.push(new Date(moment(element.date, "YYYY-MM-DD")));
          }
        });

        return {
          to: new Date(moment().subtract(1, "days")),
          dates: disable_dates,
          customPredictor: function (date) {
            let aux = true;
            let dateFormat =
              date.getFullYear() + "-" + date.getMonth() + "-" + date.getDate();
            if (date.getDay() == 1) {
              open_dates.forEach((element) => {
                let openDate =
                  element.getFullYear() +
                  "-" +
                  element.getMonth() +
                  "-" +
                  element.getDate();
                if (openDate == dateFormat) {
                  aux = false;
                }
              });

              return aux;
            }
          },
        };
      } catch (e) {
        return [];
      }
    },
  },
  async mounted() {
    this.loadingData = true
    this.MainDepartamento = localStorage.getItem("GolfDepartment");
    await this.getSubcategoria()
    await this.getTemporadas();
    await this.getTiposJuego();
    await this.getConfig();
    await this.getCajeros()
    await this.getHorarios()
    await this.getTarifarios();
    await this.getConcierges();
    await this.getUserGroups();
    if (!this.isWeb && !this.isHotel) {
      this.$store.commit("setTypePaid", 2);
      this.isAdmin = true;
    }

    this.$emit("useNav", true);
    this.$store.commit("setGlobalPrice", 190);
    this.init();
    this.loadingData = false

    //this.testRealTime();
  },
  async beforeMount() { },
  created() {
    setInterval(() => {
      let fecha = new moment();
      this.actualDate = fecha; //.format("YYYY-MM-DD HH:mm:ss");
    }, 1000);
  },
  watch: {},
};
</script>

<style>
@import "~vue-context/dist/css/vue-context.css";


.noShowCard {
  background: repeating-linear-gradient(-45deg, #fff 0 20px, #c8c8c8 0 40px) !important;
}

.cardDisabled {
  background: #607d8b59 !important;
}

.cardDisable .button {
  background: unset;
}

.input input {
  border-bottom: 1px solid black;
  width: 100%;
}

@keyframes scrolling {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(-100%);
  }
}

@media only screen and (max-width: 600px) {
  .paidDescription {
    display: none !important;
  }
}

.vdp-datepicker__calendar {
  width: 100% !important;
}

.itemLabel {
  max-width: 100%;
}

/* Responsive adjustments for labels and spacing */
@media (max-width: 1264px) {
  .stat-label {
    font-size: 0.65rem;
  }

  .stat-value {
    font-size: 1rem;
  }

  .player-name-modern {
    font-size: 0.85rem !important;
  }
}

@media (max-width: 960px) {
  .sticky-nav {
    position: relative;
    top: 0;
  }

  .date-btn-modern {
    font-size: 0.75rem;
    margin: 0 2px !important;
  }
}

.teeTimes table {
  border: 1px solid #ccc;
  border-collapse: collapse;
  margin: 0;
  padding: 0;
  width: 100%;
  table-layout: fixed;
}

.teeTimes table caption {
  font-size: 1.5em;
  margin: 0.5em 0 0.75em;
}

.teeTimes table tr {
  background-color: #f8f8f8;
  border: 1px solid #ddd;
  padding: 0.35em;
}

.teeTimes table th,
.teeTimes table td {
  padding: 0.625em;
  text-align: center;
  padding: 12px !important;
}

.teeTimes table th {
  font-size: 0.85em;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

@media screen and (max-width: 600px) {
  .teeTimes table {
    border: 0;
  }

  .teeTimes table caption {
    font-size: 1.3em;
  }

  .teeTimes table thead {
    border: none;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
  }

  .teeTimes table tr {
    border-bottom: 3px solid #ddd;
    display: block;
    margin-bottom: 0.625em;
    display: table;
  }

  .teeTimes table td.respon {
    display: table-row;
    border-bottom: 1px solid #ddd;
    display: block;
    font-size: 0.8em;
    text-align: right;
    height: auto !important;
    width: 100% !important;
    padding: 15px !important;
  }

  .teeTimes table td .v-card {
    height: 74px;
    min-width: 78px;
    padding: 0 19.5555555556px;
  }
}


.stat-card {
  height: 100% !important;
  min-height: 85px;
  border-radius: 12px !important;
  border: 1px solid rgba(0, 0, 0, 0.05) !important;
  transition: all 0.3s ease;
  background: white !important;
}

.stat-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important;
}

.stat-label {
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  color: #64748b;
  letter-spacing: 0.5px;
}

.stat-value {
  font-size: 1.15rem;
  font-weight: 800;
  color: #1e293b;
}

.sticky-nav {
  top: 64px;
  z-index: 6;
  position: sticky;
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(0, 0, 0, 0.08) !important;
  border-radius: 0 !important;
  margin-bottom: 16px;
}

.date-btn-modern {
  text-transform: none !important;
  font-weight: 600 !important;
  border-radius: 12px !important;
  margin: 0 4px !important;
  height: 40px !important;
  border: 1px solid #e2e8f0 !important;
  background: white !important;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.date-btn-modern.v-btn--active {
  background: var(--v-primary-base) !important;
  color: #1e293b !important;
  border-color: var(--v-primary-base) !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
}

.search-field-modern {
  border-radius: 14px !important;
}

.search-field-modern fieldset {
  border: 1.5px solid #e2e8f0 !important;
}

.teeTimes-modern {
  background: transparent !important;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 8px;
}

.teeTimes-modern table {
  border-collapse: separate !important;
  border-spacing: 0 8px !important;
  width: 100%;
  table-layout: fixed;
}

.time-column-modern {
  background: #f8fafc;
  font-weight: 800 !important;
  color: #1e293b !important;
  font-size: 1.1rem !important;
  border-radius: 14px 0 0 14px !important;
  border: 1.5px solid #f1f5f9 !important;
  border-right: none !important;
  text-align: center;
  width: 90px;
  padding: 0 16px !important;
}

.slot-column-modern {
  background: white !important;
  border-top: 1.5px solid #f1f5f9 !important;
  border-bottom: 1.5px solid #f1f5f9 !important;
  padding: 10px 8px !important;
  vertical-align: middle !important;
  border-right: 1.5px solid #f1f5f9 !important;
  min-width: 120px;
  max-width: 0 !important;
  overflow: hidden !important;
}

.slot-column-modern:last-child {
  border-radius: 0 14px 14px 0 !important;
}

.player-card-modern {
  border-radius: 12px !important;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;
  border: 1px solid rgba(0, 0, 0, 0.05) !important;
  position: relative;
  overflow: hidden !important;
  max-width: 100% !important;
}

.player-card-modern:hover {
  transform: translateY(-2px) scale(1.01);
  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.1) !important;
  z-index: 10;
}

.status-accent {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
}

.player-card-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
}

.player-name-modern {
  font-weight: 800 !important;
  font-size: 0.95rem !important;
  line-height: 1.2;
}

.folio-label-modern {
  font-family: 'JetBrains Mono', 'Monaco', monospace;
  font-size: 0.8rem !important;
  background: rgba(255, 255, 255, 0.2);
  padding: 1px 6px;
  border-radius: 6px;
  backdrop-filter: blur(4px);
  display: inline-flex;
  align-items: center;
}

.receipt-label-modern {
  font-family: 'JetBrains Mono', 'Monaco', monospace;
  font-size: 0.8rem !important;
  background: rgba(0, 0, 0, 0.1);
  padding: 1px 6px;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
}

.transaction-info-modern {
  line-height: 1.1;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 4px;
}

.cart-indicator-modern {
  padding: 2px 8px;
  background: rgba(255, 255, 255, 0.9);
  color: #1e293b !important;
  border-radius: 8px;
  font-size: 0.7rem;
  font-weight: 800;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.opacity-70 {
  opacity: 0.7;
}

.opacity-80 {
  opacity: 0.8;
}

.add-slot-btn-modern {
  border: 2px dashed #e2e8f0 !important;
  background: #f8fafc !important;
  color: #94a3b8 !important;
  border-radius: 12px !important;
  height: 60px !important;
  transition: all 0.2s ease !important;
  width: 100% !important;
  max-width: 100% !important;
  overflow: hidden !important;
}

.add-slot-btn-modern .v-btn__content {
  width: 100%;
  max-width: 100%;
}

@keyframes marquee {
  from {
    transform: translateX(100%);
  }

  to {
    transform: translateX(-100%);
  }
}




.add-slot-btn-modern:hover {
  border-color: var(--v-primary-base) !important;
  color: var(--v-primary-base) !important;
  background: #f1f5f9 !important;
  transform: scale(0.99);
}

.noShowOpacity {
  opacity: 0.55;
  filter: grayscale(0.8);
}

.noShowOpacity::after {
  content: "NO-SHOW";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(-15deg);
  font-size: 1.2rem;
  font-weight: 900;
  color: rgba(0, 0, 0, 0.2);
  pointer-events: none;
}

@media screen and (max-width: 1440px) {
  .player-name-modern {
    font-size: 0.85rem !important;
  }

  .slot-column-modern {
    min-width: 140px;
  }
}

@media screen and (max-width: 1100px) {
  .player-name-modern {
    font-size: 0.75rem !important;
  }

  .slot-column-modern {
    min-width: 110px;
    padding: 10px 4px !important;
  }

  .cart-indicator-modern {
    scale: 0.8;
    top: 0;
    right: 0;
  }
}

@media screen and (max-width: 600px) {

  .teeTimes-modern table,
  .teeTimes-modern tbody,
  .teeTimes-modern tr,
  .teeTimes-modern td {

    table-layout: fixed;
    display: block !important;
    width: 100% !important;
    max-width: none !important;
    border-radius: 0 !important;
    border: none !important;
  }

  .time-column-modern {
    background: #1e293b !important;
    color: white !important;
    border-radius: 14px 14px 0 0 !important;
    padding: 12px !important;
    text-align: left !important;
  }

  .slot-column-modern {
    border-left: 1.5px solid #f1f5f9 !important;
    border-right: 1.5px solid #f1f5f9 !important;
    padding: 8px 16px !important;
  }

  .slot-column-modern:last-child {
    border-radius: 0 0 14px 14px !important;
    border-bottom: 1.5px solid #f1f5f9 !important;
  }
}
</style>
